(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const affiliateRequestTypes = document.querySelectorAll('[data-affiliate-request-type]');

  affiliateRequestTypes.forEach((requestType) => {
    const form = requestType.closest('form');
    const affiliateFields = form.querySelector('[data-affiliate-fields]');
    const requiredFields = form.querySelectorAll('[data-affiliate-required]');
    const contextField = form.querySelector('[data-contact-context]');

    if (!affiliateFields) return;

    const requestedIntent = new URLSearchParams(window.location.search).get('contact_intent');
    if (requestedIntent === 'affiliate') {
      requestType.value = 'Affiliate partnership application';
    } else if (requestedIntent === 'support') {
      requestType.value = 'Product or order question';
    }

    const updateAffiliateFields = () => {
      const isAffiliateApplication = requestType.value === 'Affiliate partnership application';

      affiliateFields.hidden = !isAffiliateApplication;
      if (contextField) {
        contextField.value = isAffiliateApplication ? 'Affiliate partnership intake' : 'General contact request';
      }
      requiredFields.forEach((field) => {
        field.disabled = !isAffiliateApplication;
        field.setAttribute('aria-required', isAffiliateApplication ? 'true' : 'false');

        if (isAffiliateApplication) {
          field.setAttribute('required', 'required');
        } else {
          field.removeAttribute('required');
        }
      });
    };

    requestType.addEventListener('change', updateAffiliateFields);
    updateAffiliateFields();
  });


  (() => {
      const storageKey = 'barbarianGoldWithdrawalReceipt';
      const form = document.getElementById('WithdrawalFunctionForm');
  
      if (form) {
        form.addEventListener('submit', () => {
          const data = new FormData(form);
          const receipt = {
            name: data.get('contact[Customer name]') || '',
            email: data.get('contact[email]') || '',
            order: data.get('contact[Order or contract identifier]') || '',
            items: data.get('contact[Goods or contract part]') || '',
          };
  
          try {
            sessionStorage.setItem(storageKey, JSON.stringify(receipt));
          } catch (error) {
            return;
          }
        });
      }
  
      const details = form ? form.querySelector('.withdrawal-function__details') : null;
      const close = form ? form.querySelector('[data-withdrawal-close]') : null;
  
      if (details && close) {
        close.addEventListener('click', () => {
          details.open = false;
          details.querySelector('summary')?.focus();
        });
      }
  
      const success = document.querySelector('[data-withdrawal-success]');
      const download = document.querySelector('[data-withdrawal-download]');
  
      if (!success || !download) return;
  
      let receipt = {};
      try {
        receipt = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        sessionStorage.removeItem(storageKey);
      } catch (error) {
        receipt = {};
      }
  
      const lines = [
        success.dataset.receiptTitle,
        '',
        `${success.dataset.declarationLabel}: ${success.dataset.declaration}`,
        `${success.dataset.nameLabel}: ${receipt.name || ''}`,
        `${success.dataset.emailLabel}: ${receipt.email || ''}`,
        `${success.dataset.orderLabel}: ${receipt.order || ''}`,
        `${success.dataset.itemsLabel}: ${receipt.items || ''}`,
        `${success.dataset.receivedLabel}: ${success.dataset.receivedAt}`,
      ];
      const file = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(file);
      download.href = url;
      setTimeout(() => download.click(), 250);
      window.addEventListener('pagehide', () => URL.revokeObjectURL(url), { once: true });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const stories = document.querySelectorAll('.bg-story');

    stories.forEach((story) => {
      const links = Array.from(story.querySelectorAll('.bg-story__nav-link'));
      const sections = Array.from(story.querySelectorAll('.bg-story__section[id]'));
      if (!links.length || !sections.length || !('IntersectionObserver' in window)) return;

      const setCurrent = (id) => {
        links.forEach((link) => {
          if (link.getAttribute('href') === `#${id}`) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      };

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) setCurrent(visible.target.id);
        },
        { rootMargin: '-22% 0px -58%', threshold: [0.05, 0.25, 0.5] }
      );

      sections.forEach((section) => observer.observe(section));
      links.forEach((link) => {
        link.addEventListener('click', () => setCurrent(link.getAttribute('href').slice(1)));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-real-life-proof"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-shop-proof]').forEach(function(section) {
    var rail = section.querySelector('[data-shop-proof-rail]');
    if (!rail) return;

    section.querySelectorAll('[data-shop-proof-scroll]').forEach(function(button) {
      button.addEventListener('click', function() {
        var direction = Number(button.getAttribute('data-shop-proof-scroll'));
        rail.scrollBy({ left: rail.clientWidth * 0.82 * direction, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
